<template>
  <div class="base-question">
    <div class="base-question-header">
      <p class="base-question-text">
        {{ questionText }}
        <span v-if="tooltip" class="base-question-tooltip-wrap">
          <i class="pi pi-info-circle base-question-icon"></i>
          <span class="base-question-bubble">{{ tooltip }}</span>
        </span>
      </p>
    </div>
    <div class="base-question-body">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BaseQuestion',
  props: {
    questionText: {
      type: String,
      default: '',
    },
    tooltip: {
      type: String,
      default: null,
    },
  },
};
</script>

<style scoped>
.base-question {
  width: 100%;
}

.base-question-header {
  margin-bottom: clamp(0.25rem, 0.8vw, 0.5rem);
}

.base-question-text {
  text-align: center;
  padding: clamp(0.25rem, 1vw, 1rem) 0;
  font-size: clamp(1rem, 1.2vw + 0.6rem, 1.75rem);
  font-weight: 500;
  line-height: 1.35;
  color: #1E2019;
  margin: 0;
}

.base-question-tooltip-wrap {
  position: relative;
  display: inline-block;
  margin-left: 0.25rem;
}

.base-question-icon {
  color: #e4821a;
  cursor: help;
  font-size: 1rem;
  transition: transform 0.15s ease;
}

.base-question-tooltip-wrap:hover .base-question-icon {
  transform: scale(1.15);
}

.base-question-bubble {
  visibility: hidden;
  width: 180px;
  max-width: 90vw;
  background: #1E2019;
  color: #fff;
  text-align: center;
  border-radius: 0.5rem;
  padding: 0.5rem 0.75rem;
  position: absolute;
  z-index: 10;
  bottom: 100%;
  left: 50%;
  transform: translateX(-50%);
  margin-bottom: 0.5rem;
  font-size: 0.875rem;
  font-weight: 400;
  line-height: 1.4;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

.base-question-tooltip-wrap:hover .base-question-bubble {
  visibility: visible;
}

.base-question-body {
  width: 100%;
  position: relative;
  z-index: 0;
}

@media (max-width: 1023px) {
  .base-question-header {
    margin-bottom: 0.25rem;
  }
}
</style>
